import React from 'react';
import { Tooltip, Checkbox, FormControlLabel } from '@material-ui/core';
import { upsertSelectedMetric } from '../../../helpers';
import { withStyles } from '@material-ui/core/styles';
import { MetricsTableStyles } from './MetricsTableStyles';
import clsx from 'clsx';
import Track from '../../../helpers/Analytics';

const SelectableGeography = ({ metric, geo, selectedGeographies, selectedMetrics, onMetricsSelected, classes }) => {
  const checked = !!selectedGeographies.find(sg => sg.id === geo.id && sg.selected);
  const checkboxTitle = checked ? 'Remove geography from chart only' : 'Add geography to chart';
  return (
    <Tooltip enterDelay={300} title={checkboxTitle}>
      <div>
        <FormControlLabel
          classes={{
            label: classes.MetricsTable_SelectableGeographies
          }}
          control={
            <Checkbox
              checked={checked}
              icon={<span className={classes.icon} />}
              checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
              onChange={event => {
                onMetricsSelected(
                  upsertSelectedMetric(
                    metric,
                    {
                      geographies: selectedGeographies.map(sg => ({
                        selected: geo.id === sg.id ? event.target.checked : sg.selected,
                        id: sg.id,
                        name: sg.name
                      }))
                    },
                    selectedMetrics
                  )
                );
                Track('Metric',  { id: "Geo-Toggle", metric: metric.name, geo: geo.name, checked: event.target.checked });
              }}
            />
          }
          label={geo.name}
        />
      </div>
    </Tooltip>
  );
};

export default withStyles(MetricsTableStyles)(SelectableGeography);

// export default SelectableGeography
